/**
 * Landing page API functions
 */

import { LandingPageFallbackData } from '../fallback-data/landing-page';
import { LandingPageData, StrapiResponse } from '../types';
import { STRAPI_URL } from './base';

/**
 * Fetch landingPage data including header and footer content
 * @returns Promise with landingPage data
 */
export async function fetchLandingPageData(): Promise<LandingPageData> {
  try {
    // Since we updated the backend controller to handle populate internally,
    // we can use a simpler query that just requests the data
    const response = await fetch(`${STRAPI_URL}/api/landingpage`, {
      headers: {
        'Content-Type': 'application/json',
        ...(process.env.NEXT_PUBLIC_STRAPI_API_TOKEN && {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
        }),
      },
      next: { revalidate: 60 }, // Cache for 1 minute
    });

    if (!response.ok) {
      console.error('HTTP error! status:', response.status);
      return LandingPageFallbackData;
    }

    const result: StrapiResponse<LandingPageData> = await response.json();

    if (!result.data) {
      return LandingPageFallbackData;
    }

    return result.data;
  } catch (error) {
    console.error('Error fetching landingPage data:', error);
    // Return fallback data instead of throwing error during build
    return LandingPageFallbackData;
  }
}
